// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton } from '@node-space/ui-components'
import SafeGuardIcon from 'components/wallets/SafeguardIcon'
import { useWalletContext } from 'hooks/context'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { WalletBalance } from './WalletBalance'
import { WalletButtonsCrypto } from './WalletButtonsCrypto'
import { WalletButtonsFiat } from './WalletButtonsFiat'

interface WalletDetailsHeaderProps {
  isLoading?: boolean
}

export const WalletDetailsHeader = ({ isLoading }: WalletDetailsHeaderProps) => {
  const { t } = useTranslation()
  const wallet = useWalletContext()
  const { viewOnly } = useProfileContext()

  if (isLoading || !wallet) {
    return (
      <Box className="pb-6">
        <Box className="rounded bg-surface-static animate-pulse h-10 w-2/5 " />
      </Box>
    )
  }

  const isEmoney = wallet.isEmoney

  return (
    <Box flexCol justify="between" className="mb-6 sm:flex-row">
      <Box>
        <Box flex align="center" gap={8}>
          <p
            className="text-body-regular text-foreground-subdued"
            data-testid="wallet-balance-header"
          >
            {`${wallet?.description} ${t('wallets.walletBalance')}`}
          </p>
          {isEmoney && <SafeGuardIcon />}
        </Box>
        <WalletBalance />
      </Box>
      <Box flex flexCol gap={20} className="sm:items-end">
        <Box flex align="center" gap={4} paddingX={8}>
          <p className="text-foreground-subdued text-body-regular-small">
            {t('wallets.walletId')}
            {wallet?.lsid}
          </p>
          <CopyButton copyText={wallet?.lsid} />
        </Box>
        {wallet?.currency?.fiat ? (
          <WalletButtonsFiat disabled={viewOnly} />
        ) : (
          <WalletButtonsCrypto disabled={viewOnly} />
        )}
      </Box>
    </Box>
  )
}
